import React, { FC,useEffect,useState } from 'react'
import { Space, DatePicker, Card, Button, Table, Empty, message, Input, TimeRangePickerProps, Modal } from 'antd';
import { useLocation } from 'react-router-dom';
import styles from './index.module.scss'
type PickerMode = 'time' | 'date' | 'week' | 'month' | 'quarter' | 'year';
import { columns, DataType, OverViewDataType, overViewColumns, productColumns, productDataType } from './column';
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import { summaryData, chartsAndOverview, cycleInfoList, productAnalysis} from "@/services/dataBoard"
import { ResDataType } from '@/services/ajax';
import usePagAndCommon from '@/hooks/usePagAndCommon';
import { debounce } from "@/utils";
import { getSafeLocale } from "@/constant"
import 'dayjs/locale/zh-cn'; 
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from 'recharts';
const { RangePicker } = DatePicker;

interface ChartsDataType {
    name: string;
    value: number;
}
const DataBoard: FC = () => {
    
    const dataShow = [
        { title: '权益包数量', value: 'activityCount' },
        { title: '核销成本', value: 'costPrice' },
        { title: '活动参与人数', value: 'userCount' },
    ]
    const location = useLocation();
    const reload = location.state?.reload;
    const { flag,setFlag,isModalOpen,setIsModalOpen } = usePagAndCommon();
    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
    const [loading, setLoading] = useState<boolean>(false);
    const [summary,setSummary] = useState<{ [key: string]: number }>({});
    const [chartsData, setChartsData] = useState<ChartsDataType[]>([]);
    const [colorData, setColorData] = useState<string[]>([]);
    const [overViewData, setOverViewData] = useState<OverViewDataType[]>([]);
    const [dateShow, setDateShow] = useState<null | [Dayjs | null, Dayjs | null]>(null);
    const [productData, setProductData] = useState<productDataType[]>([]);
    const [dataPickertype, setDataPickertype] = useState<PickerMode |undefined>('date')
    const [data,setData] = useState<DataType[]>([]);
    const [privId,setPrivId] = useState<string>('');

    const getRandomColor = () => {
        const hex = Math.floor(Math.random() * 0xFFFFFF).toString(16);
        return `#${hex.padStart(6, '0')}`; 
    };
    const presetsDate = [
        {
          label: '最近一周',
          value: [dayjs().subtract(7, 'day'), dayjs()],
        },
        {
            label: '本周',
            value: [dayjs().startOf('week'), dayjs().endOf('week')],
        },
        {
            label: '本月',
            value: [dayjs().startOf('month'), dayjs().endOf('month')],
        },
    ];

    const presetsMonth = [
        {
          label: '最近一个月',
          value: [dayjs().subtract(1, 'month'), dayjs()],
        }, 
        {
            label: '最近三个月',
            value: [dayjs().subtract(3,'month'), dayjs()], 
        },
        {
            label: '最近六个月',
            value: [dayjs().subtract(6,'month'), dayjs()], 
        }
    ]

    const getChartsOverViewData = async (start:string='',end:string='') => {
        setFlag(true)
        const res = await chartsAndOverview(start,end) as ResDataType;
        if (res.code != 0) {
            message.error(res.message);
        } else {
            setOverViewData(res.data.overviewDatas);
            const chartsData = res.data.productDatas.map((ite:{productName:string, exchangeCount:number})=> {
                return {
                    name: ite.productName,
                    value: ite.exchangeCount
                }
            })
            setChartsData(chartsData);
            setColorData(chartsData.map(() => getRandomColor()));
        }
        setFlag(false)
    }
    const getCycleInfoList = async (id:number) => {
        setLoading(true)
        const res = await cycleInfoList(id) as ResDataType;
        if (res.code!= 0) {
            message.error(res.message);
        } else {
            setData(res.data.list);
        }
        setLoading(false)
    }

    const getProductAnalysis = async (id:number) => {
        setLoading(true)
        const res = await productAnalysis(id) as ResDataType; 
        if (res.code!= 0) {
            message.error(res.message); 
        } else {
            setProductData(res.data.list); 
        }
        setLoading(false)
    }
    
    const getSummaryData = async () => {
        setFlag(true)
        const res = await summaryData() as ResDataType;
        if (res.code != 0) {
            message.error(res.message);
        } else {
            setSummary(res.data);
        }
        setFlag(false)
    }
    useEffect(()=> {
        setPrivId('')
        setDateShow(null)
        setData([])
        setOverViewData([])
        setChartsData([])
        getChartsOverViewData();
        getSummaryData()
    },[reload])

    const changePickerType = (type:PickerMode) => {
        setDataPickertype(type);
        getChartsOverViewData();
        setDateShow(null)
    }

    const getLastDayOfMonth = (year:number, month:number)=> { // month 从 1 开始（1=1月，12=12月）
        const adjustedMonth = month - 1; // 转为 Day.js 所需的 0-11
        const date = dayjs()
          .year(year)
          .month(adjustedMonth)
          .endOf('month');
        return date.date();
    }
      

    const datePickerChange = (dates: null | [Dayjs | null, Dayjs | null], dateString: string[]) => {
        setDateShow(dates);
        let dateList = []
        if (dataPickertype == 'date') {
            dateList = dateString
        } else {
            const eyam = dateString ? dateString[1].split('-') : []
            dateList = dateString[0] ? [
                `${dateString[0]}-01`,
                `${dateString[1]}-${getLastDayOfMonth(Number(eyam[0]),Number(eyam[1]))}`
            ]:[]
        }
        getChartsOverViewData(dateList[0],dateList[1])
    };

    const titleASearch = ()=>{
        return (
           <Space size="large">
                <h4 style={{ fontWeight:800 }}>权益领取详情</h4>
                <Input allowClear placeholder="权益包编号" value={privId} onPressEnter={(e:any)=>{
                    handleSearch(e.target.value)
                }} onChange={(e:any)=>{
                    setPrivId(e.target.value)
                    handleSearch(e.target.value)
                }} />
           </Space> 
        )
    }

    const debouncedSearch = debounce((value:number) => {
        getCycleInfoList(value)
    });

    const handleSearch = (value:number) => {
        debouncedSearch(value);
    };
    return (
    <>
    <div className={styles.card}>
        <Card title="数据总览" variant="borderless">
                <div className={styles.dataBoard}>
                    {   
                        dataShow.map((item,index) => {
                        return (
                            <div key={index}>
                                <Space className={styles.dataShow} size='small' direction='vertical' key={index}>
                                    <h2>{item.title}</h2>
                                    <h1>{summary[item.value]}</h1>
                                </Space>
                            </div>
                        )
                        })
                    }
                
                </div>
        </Card>
    </div>
        
    <div className={styles.card} style={{ display:'flex', justifyContent:'space-between' }}>
        <Card title="权益概况" variant="borderless" style={{ width:'69%' }}>
            <div className='flexBox'>
                <RangePicker locale={getSafeLocale} value={dateShow} onChange={datePickerChange} 
                presets={(dataPickertype == 'date' ? presetsDate : presetsMonth) as TimeRangePickerProps['presets']}
                picker={dataPickertype} placeholder={['开始日期', '结束日期']} format={dataPickertype == 'date' ? 'YYYY-MM-DD' : 'YYYY-MM'}/>
                <Space size='small'>
                    <Button color="primary" variant={dataPickertype == 'date' ? 'outlined': undefined} onClick={()=>{ changePickerType('date') }}>日</Button>
                    <Button color="primary" variant={dataPickertype == 'month' ? 'outlined': undefined} onClick={()=>{ changePickerType('month') }}>月</Button>
                </Space>
            </div>
            <div style={{ margin:'20px 0' }}>
                <Table<OverViewDataType> rowKey="collectionTime" loading={flag} columns={[
                    ...overViewColumns,
                    {
                        title: '日期',
                        dataIndex: 'collectionTime',
                        key: 'collectionTime',
                        render(value, record, index) {
                            return (
                                <p>{record.collectionTime && dayjs(record.collectionTime ).format("YYYY-MM-DD")}</p>
                            );
                        },
                    }
                ]} pagination={false} dataSource={overViewData}
                scroll={{ y: 280 }}
                locale={{ emptyText: <Empty description="暂无数据"></Empty> }} />
            </div>
            
        </Card>
        <Card title="" variant="borderless" style={{ width:'30%' }}>
            {
                chartsData.length > 0 ?
                <>
                    <ResponsiveContainer width="100%" height={395}>
                        <PieChart >
                            <Pie
                                data={chartsData}
                                cx="50%"
                                cy="50%"
                                labelLine={false}
                                outerRadius={180}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                {chartsData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={colorData[index]} />
                                ))}
                            </Pie>
                            <Tooltip />
                        </PieChart>
                        
                    </ResponsiveContainer>
                    
                </>
                : <Empty style={{ width:'100%',height:'400px',marginInline:'0' }} description="暂无数据"></Empty>
            }
            <h3 style={{ textAlign:'center' }}>
                权益领取分布
            </h3>
        </Card>
    </div>

    <div className={styles.card}>
        <Card title={titleASearch()} variant="borderless">
            <Table<DataType> loading={loading} scroll={{ y: 400 }} rowKey="activityCycleId"
             columns={[
                ...columns,
                {
                    title:'操作',
                    key:'action',
                    render:(_,record)=>{
                        return <Button type="link" onClick={()=>{
                            getProductAnalysis(record.activityCycleId)
                            setIsModalOpen(true);
                        }}>权益分析</Button>
                    }
                }
             ]} 
             pagination={false} dataSource={data} locale={{ emptyText: <Empty description="暂无数据"></Empty> }} />
        </Card>
    </div>
        <Modal width={700} title="权益分析" open={isModalOpen} okText="确定" cancelText="取消" onOk={()=>{setIsModalOpen(false)}} onCancel={()=>{ setIsModalOpen(false) }}>
            <Table<productDataType>  loading={loading} scroll={{ y: 400 }} rowKey="prouctId"
             columns={productColumns} 
             pagination={false} dataSource={productData} locale={{ emptyText: <Empty description="暂无数据"></Empty> }} />
      </Modal>
    </>
  )
}

export default DataBoard
